export type AppEnvironment = 'staging' | 'production';

export enum ENVIRONMENT {
  UAT = 'staging',
  PRODUCTION = 'production',
}

const mode = (import.meta.env.VITE_APP_ENV ||
  ENVIRONMENT.UAT) as AppEnvironment;

const ENVIRONMENT_SPECIFIC_URLS: Record<
  ENVIRONMENT,
  {
    ALBERTA_ACCOUNT_SETTINGS: string;
    ALBERTA_ACCOUNT_VERIFICATION: string;
    CLOSE_ACCOUNT: string;
  }
> = {
  [ENVIRONMENT.UAT]: {
    ALBERTA_ACCOUNT_SETTINGS:
      'https://ppe.myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-AS',
    ALBERTA_ACCOUNT_VERIFICATION:
      'https://ppe.myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-IV',
    CLOSE_ACCOUNT:
      'https://ppe.myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-CA',
  },
  [ENVIRONMENT.PRODUCTION]: {
    ALBERTA_ACCOUNT_SETTINGS:
      'https://myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-AS',
    ALBERTA_ACCOUNT_VERIFICATION:
      'https://myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-IV',
    CLOSE_ACCOUNT:
      'https://myhealth.alberta.ca/Pages/Navigator.aspx?pf=MMA-M-CA',
  },
};

export const EXTERNAL_LINKS = {
  ALBERTA_ACCOUNT_SETTINGS:
    ENVIRONMENT_SPECIFIC_URLS[mode].ALBERTA_ACCOUNT_SETTINGS,
  ALBERTA_ACCOUNT_VERIFICATION:
    ENVIRONMENT_SPECIFIC_URLS[mode].ALBERTA_ACCOUNT_VERIFICATION,
  CLOSE_ACCOUNT: ENVIRONMENT_SPECIFIC_URLS[mode].CLOSE_ACCOUNT,
  TERMS_OF_SERVICE: 'https://myhealth.alberta.ca/Pages/Terms-Conditions.aspx',
  PROVIDE_FEEDBACK: 'https://extranet.gov.ab.ca/opinio6/s?s=68037',
  CREATE_NEW_ACCOUNT:
    'https://account.alberta.ca/ui/sign-in/create-new-account',
};
